/**
 * "Usual" formats:
 * - allows +country, spaces, (), /, -, dots
 * - allows optional extension (x123, ext 123, #123)
 * - rejects letters and too-short/too-long numbers
 */
export function isValidPhone(input: string): boolean {
  const value = (input || '').trim();
  if (!value) return true; // optional fields -> empty is ok

  // remove everything except digits to validate length
  const digits = value.replace(/\D/g, '');
  if (digits.length < 6 || digits.length > 20) return false;

  // allowed overall structure (no letters), extension allowed at end
  const re = /^\+?[\d\s().\/-]+(\s*(ext\.?|x|#)\s*\d{1,6})?$/i;
  return re.test(value);
}

// User hint; keep it generic and international
export const phonePlaceholder: string = '+49 89 123456-0';